var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mc-trackvideo-card__item mc-trackvideo-card__item--nochoice"},[_c('div',{staticClass:"mc-trackvideo-card__item-wrapper"},[_c('div',{staticClass:"mc-trackvideo-card-body"},[_c('div',{staticClass:"mc-trackvideo-card-body-content"},[_c('NoVideo')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }